export const isReturningCirclesUserLocalStorageKey = 'isReturningCirclesUser'
export const isComingFromJoinQueryParamName = 'isComingFromJoin'
export const circleIdQueryParamName = 'circleId'
export const isExploreQueryParamName = 'isExplore'
export const tabQueryParamName = 'tab'
export const jumpToMessageIdQueryParamName = 'jumpToMessageId'
export const jumpToThreadIdQueryParamName = 'jumpToThreadId'

export const entityIdsQueryParamName = 'entityIds'
